import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getStyle, SERVICE_CHAIN } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSubHeading from '../../shared/CBSubHeading';
import {
  fetchBusinessUnits as _fetchBusinessUnits,
  createBusinessUnit as _createBusinessUnit,
  updateBusinessUnit as _updateBusinessUnit,
  deleteBusinessUnit as _deleteBusinessUnit,
} from '../../../actions/businessUnitActions';
import BusinessUnitRow from './BusinessUnitRow';

// Toimipisteet (business units) of an organization. Used by the fleet portal
// (organization from the settings selector) and by the chain portal, which
// passes `organizationId` for the customer it is editing.
class SettingsBusinessUnits extends React.Component {
  componentDidMount() {
    this.fetchUnits();
  }

  componentDidUpdate(prevProps) {
    if (this.getOrganizationId(prevProps) !== this.getOrganizationId()) {
      this.fetchUnits();
    }
  }

  getOrganizationId = (props) => {
    const p = props || this.props;
    return p.organizationId || p.selectedOrganizationId;
  };

  getService = () => this.props.service || this.props.appService;

  fetchUnits = () => {
    const organizationId = this.getOrganizationId();
    if (organizationId && organizationId !== 'all') {
      this.props.fetchBusinessUnits(organizationId);
    }
  };

  getUserRole = () => {
    const { user } = this.props;
    const organizationId = this.getOrganizationId();
    if (!user || !user.organizations || !organizationId) return null;
    const organization = user.organizations.find((org) => org.id == organizationId);
    return organization ? organization.user_role : null;
  };

  canEdit = () => {
    const { user } = this.props;
    if (user && user.is_staff) return true;
    // The chain route is already admin/manager-gated.
    if (this.getService() === SERVICE_CHAIN) return true;
    const role = this.getUserRole();
    return role === 'admin' || role === 'manager';
  };

  render() {
    const {
      t, businessUnits, createBusinessUnit, updateBusinessUnit, deleteBusinessUnit, embedded,
    } = this.props;
    const organizationId = this.getOrganizationId();
    const canEdit = this.canEdit();

    if (!organizationId || organizationId === 'all') {
      return null;
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, embedded ? 'embeddedContainer' : 'container')}>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <CBSubHeading>{t('heading')}</CBSubHeading>
            </div>
            <div style={getStyle(screenSize, styles, 'sectionContainer')}>
              <p>{t('description')}</p>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table>
                <thead>
                  <tr>
                    <th style={getStyle(screenSize, styles, 'tableHeading')}>{t('nameLabel')}</th>
                    <th style={getStyle(screenSize, styles, 'tableHeading')} />
                  </tr>
                </thead>
                <tbody>
                  {businessUnits.map((unit) => (
                    <BusinessUnitRow
                      key={unit.id}
                      businessUnit={unit}
                      organizationId={organizationId}
                      canEdit={canEdit}
                      createBusinessUnit={createBusinessUnit}
                      updateBusinessUnit={updateBusinessUnit}
                      deleteBusinessUnit={deleteBusinessUnit}
                    />
                  ))}
                  {!businessUnits.length && (
                    <tr>
                      <td style={getStyle(screenSize, styles, 'emptyCell')} colSpan={2}>{t('noBusinessUnits')}</td>
                    </tr>
                  )}
                  {canEdit && (
                    <BusinessUnitRow
                      isNew
                      organizationId={organizationId}
                      canEdit
                      createBusinessUnit={createBusinessUnit}
                      updateBusinessUnit={updateBusinessUnit}
                      deleteBusinessUnit={deleteBusinessUnit}
                    />
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      padding: 32,
      display: 'flex',
      flexDirection: 'column',
    },
    embeddedContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    sectionContainer: {
      marginBottom: 16,
    },
    tableHeading: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 12,
      color: '#ffffff',
      paddingLeft: 8,
      paddingBottom: 8,
      textAlign: 'left',
    },
    emptyCell: {
      color: 'rgba(255, 255, 255, 0.7)',
      padding: 8,
      fontSize: 14,
    },
  },
  medium: {
    container: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    appService: state.app.service,
    selectedOrganizationId: state.organization.selectedOrganization,
    businessUnits: state.businessUnit.businessUnits,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchBusinessUnits: _fetchBusinessUnits,
    createBusinessUnit: _createBusinessUnit,
    updateBusinessUnit: _updateBusinessUnit,
    deleteBusinessUnit: _deleteBusinessUnit,
  },
)(translate('BusinessUnits')(SettingsBusinessUnits));
